import { HashLocationStrategy, LocationStrategy } from "@angular/common";
import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, Renderer2, ViewChild } from "@angular/core";

import { combineLatest, Observable } from "rxjs";
import { map } from "rxjs/operators";

import { AktuelBrugerObserver } from "@e-forsyning/common/bruger";
import { AktuelInstallationObserver } from "@e-forsyning/common/installation";
import { AktuelBrugersInstallationerObserver } from "@e-forsyning/common/installation";

import { EforsyningMenuForSidebarObserver } from "../observers/eforsyning-menu-for-sidebar.observer";
import { EforsyningSidenavMenuViewModel } from "./eforsyning-sidenav-menu.view-model";
import { DffSidenavMenuComponent } from "../../../../../../shared/ui/src/lib/menu/dff-sidenav-menu/dff-sidenav-menu.component";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { AsyncPipe } from "@angular/common";

@Component({
    selector: "eforsyning-sidenav-menu",
    templateUrl: "./eforsyning-sidenav-menu.component.html",
    styleUrls: ["./eforsyning-sidenav-menu.component.scss"],
    imports: [DffSidenavMenuComponent, MatProgressSpinner, AsyncPipe]
})
export class EforsyningSidenavMenuComponent implements OnInit {
    public vm$: Observable<EforsyningSidenavMenuViewModel>;

    @Output()
    public itemClick = new EventEmitter<MouseEvent>();

    @Input()
    public visLoggetUdMenu = false;

    constructor(
        private readonly eforsyningSidebarMenuObserver: EforsyningMenuForSidebarObserver,
        private readonly aktuelBrugerObserver: AktuelBrugerObserver,
        private readonly aktuelBrugersInstallationerObserver: AktuelBrugersInstallationerObserver,
        private readonly aktuelInstallationObserver: AktuelInstallationObserver,
        private readonly locationStrategy: LocationStrategy,
        private menu: ElementRef
    ) {}

    @ViewChild("dropdown") public dropdown: ElementRef;
    @ViewChild("DffSidenavMenu") DffSidenavMenu: ElementRef;

    @HostListener("keydown.arrowdown", ["$event"]) onArrowDown(event: Event) {
        (event as KeyboardEvent).preventDefault();
        const focusableElementsNodeList = this.menu.nativeElement.querySelectorAll("button, [href], [tabindex]:not([tabindex='-1']");
        const focusableElementsArray = Array.from(focusableElementsNodeList);
        const focusedElement = document.activeElement;
        const currentIndex = focusableElementsArray.indexOf(focusedElement);
        const nextIndex = (currentIndex + 1) % focusableElementsArray.length;
        const nextElement = focusableElementsArray[nextIndex] as HTMLElement;
        if (nextElement !== null) {
            nextElement.focus();
        }
    }

    @HostListener("keydown.arrowup", ["$event"]) onArrowUp(event: Event) {
        (event as KeyboardEvent).preventDefault();
        const focusableElementsNodeList = this.menu.nativeElement.querySelectorAll("button, [href], [tabindex]:not([tabindex='-1']");
        const focusableElementsArray = Array.from(focusableElementsNodeList);
        const focusedElement = document.activeElement;
        const currentIndex = focusableElementsArray.indexOf(focusedElement);
        const nextIndex = (currentIndex - 1) % focusableElementsArray.length;
        const prevElement = focusableElementsArray[nextIndex] as HTMLElement;

        if (currentIndex === 0) {
            const lastElement = focusableElementsArray[focusableElementsArray.length - 1] as HTMLElement;
            lastElement.focus();
        } else if (prevElement !== null) {
            prevElement.focus();
        }
    }

    public ngOnInit(): void {
        const menuItems$ = this.eforsyningSidebarMenuObserver.valueChanges;
        const aktuelBruger$ = this.aktuelBrugerObserver.valueChanges;
        const installationer$ = this.aktuelBrugersInstallationerObserver.valueChanges;
        const aktuelInstallation$ = this.aktuelInstallationObserver.valueChanges;
        this.vm$ = combineLatest([menuItems$, aktuelBruger$, installationer$, aktuelInstallation$]).pipe(
            map(([menuItems, aktuelBruger, installationer, aktuelInstallation]) => {
                const visMenu = !!aktuelBruger || this.visLoggetUdMenu;
                const hashRouting = this.locationStrategy instanceof HashLocationStrategy;
                const installPickerHref =
                    installationer.length > 1 ? (hashRouting ? "#/install-picker" : "/install-picker") : "";
                return {
                    menuItems: visMenu ? menuItems : [],
                    aktuelInstallation,
                    visInstallationMenuItem: !!aktuelBruger,
                    vaelgInstallationHref: installPickerHref
                };
            })
        );
    }
}
